<template>
  <div class="esign-file-list">
    <toptitle :title1="title" />
    <!-- 无数据占位 -->
    <van-empty v-if="listArr.length === 0" description="暂无文件" />
    <!-- 电子签文件列表 -->
    <van-cell-group v-else>
      <van-cell
        v-for="(item, index) in listArr"
        :key="index"
        is-link
        :title="item.C_DOCTYPE_DESCR"
        :label="`签署日期：${item.SIGN_DATE}`"
        @click="handleFileClick(item)"
      />
    </van-cell-group>
  </div>
</template>

<script>
import toptitle from '../components/toptitle';
import { getEsignFileListApi } from '../request/api';
import { Toast } from 'vant';

export default {
  name: 'esignFileList',
  components: {
    toptitle
  },
  data() {
    return {
      title: '电子签署文件',
      listArr: []
    };
  },
  methods: {
    // 点击文件跳转到合同文件页，携带签署流程ID
    handleFileClick(item) {
      this.$router.push({
        path: '/contractFile',
        query: { id: item.C_SIGNFLOW_ID }
      });
    }
  },
  created() {
    // 查询当前员工电子签署文件列表
    getEsignFileListApi({
      EMPLID: sessionStorage.getItem('EMPLID')
    }).then(res => {
      // 兼容直接返回数组或 { CODE, DATA } 包裹结构
      const data = Array.isArray(res) ? res : res.DATA;
      this.listArr = data || [];
      if (!Array.isArray(res) && res.CODE !== 200) {
        Toast(res.MESSAGE);
      }
    });
  }
};
</script>

<style lang="less" scoped></style>
